// Copyright (c) 2023, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 Inc. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { Container, Grid, Link, Stack, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { DataLoader } from "../components/common/DataLoader";
import ExamTable from "../components/tables/ExamTable";
import { getRegisteredExams } from "../slices/examSlice/examHistory";
import { RootState, useAppDispatch, useAppSelector } from "../slices/store";
import { RegisteredExamsPayload } from "../utils/types";
import Loading from "./Loading";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { contactDetails } from "../config/constant";

const Exams = () => {
  const dispatch = useAppDispatch();
  const contactState = useAppSelector((state: RootState) => state.contact);
  const registeredExamState = useAppSelector(
    (state: RootState) => state.registeredExams
  );
  const authState = useAppSelector((state: RootState) => state.auth);

  useEffect(() => {
    if (authState.status === "success" && contactState.state === "success") {
      dispatch(getRegisteredExams(contactState.response.id));
    }
  }, [contactState.state]);

  const examData: RegisteredExamsPayload[] = registeredExamState.response;

  return (
    <>
      {contactState.backgroundProcess ? (
        <Loading message={contactState.backgroundProcessMessage} />
      ) : (
        <Container>
          <Grid container columnSpacing="10" mb={10}>
            <Grid
              item
              md={12}
              xs={12}
              sx={{
                mt: 5,
                pt: 10,
              }}
            >
              <Typography 
                sx={{ 
                  textTransform: 'uppercase', 
                  fontWeight: 'bold',
                  fontSize: '1.2rem'
                }}
                component="h1" variant="h4" align="left">
                  My Exams
              </Typography>
              <Typography variant="body1" align="left" component="p" mt={1}>
                You have registered for the following certification exams.
              </Typography>
            </Grid>
            <Grid item md={12}>
              {registeredExamState.backgroundProcess ? (
                <DataLoader
                  message={registeredExamState.backgroundProcessMessage}
                />
              ) : (
                <ExamTable
                  examData={examData}
                  loading={registeredExamState.backgroundProcess}
                />
              )}
            </Grid>
          </Grid>
        </Container>
      )}
    </>
  );
};

export default Exams;
